module.exports = __webpack_public_path__ + "static/media/delete-white-btn.584db3df.svg";